import { orderDraftRepository } from '@webapp/modules/purchasing/data-access/repositories/OrderDraftRepository'
import { GetOrderDraftUseCase } from './GetOrderDraftUseCase'
import { initializeOrderDraftOrgCategoriesUseCase } from '../InitializeOrderDraftOrgCategories'

export const getOrderDraftUseCase = new GetOrderDraftUseCase({
  orderDraftRepository,
  initializeOrderDraftOrgCategoriesUseCase,
}).execute
